import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbModal, NgbPopoverConfig} from "@ng-bootstrap/ng-bootstrap";
import {Observable, Subscription} from "rxjs";

import {Role} from "../../services/dtos/enums/role.enum";
import {UserDto} from "../../services/dtos/user.dto";
import {CloudApiService} from "../../services/cloud-api.service";
import {AuthenticationService} from "../../services/authentication.service";
import {UserSessionService} from "../../services/user-session.service";
import {UserManagementModalComponent} from "../modals/user-management/user-management.modal.component";
import {UserGroupRoleDto} from "../../services/dtos/user-group-role.dto";

enum State {
    None,
    Loading,
    Ready
}

@Component({
    selector: 'app-password-reset-create',
    template: require('./password-reset-create.component.html'),
    styles: [ require('./password-reset-create.component.css') ]
})
export class PasswordResetCreateComponent implements OnInit, OnDestroy {

    states = State;
    state: State = State.None;
    errorMessage: string;

    users: UserDto[] = [];
    globalUsers: UserDto[] = [];
    role = Role;

    searchUser: any;

    isGroupUser: boolean;
    isGlobalUser: boolean;

    private librarySubscription: Subscription;

    constructor(
        public userSession: UserSessionService,
        private authenticationService: AuthenticationService,
        private cloudApiService: CloudApiService,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {
        this.userAccess();

        this.librarySubscription = this.userSession.library.subscribe(library => {
            this.updateUsers();
        });
    }

    public ngOnDestroy(): void {
        this.librarySubscription.unsubscribe();
    }

    private updateUsers(): void {
        try{
            this.users = [];
            this.globalUsers = [];
            this.state = State.Loading;

            this.cloudApiService.getUsersByLibrary(this.userSession.libraryId).subscribe(
                users => {
                    this.users = users;
                    this.state = State.Ready;
                },
                error => {
                    this.errorMessage = error;
                    this.state = State.None;
                }
            );

            if(this.isGlobalUser){
                this.cloudApiService.getUsersGlobalRoles().subscribe(
                    users => {
                        this.globalUsers = users;
                        this.state = State.Ready;
                    },
                    error => {
                        this.errorMessage = error;
                        this.state = State.None;
                    }
                );
            }
        }catch (Error) {
            this.errorMessage = Error.errorMessage;
        }

    }

    private userAccess(): void{
        this.isGroupUser = this.authenticationService.isInLibraryRole(this.userSession.libraryId, Role.UserManagement);
        this.isGlobalUser = this.authenticationService.isInGlobalRole(Role.UserManagement);
    }

    checkLibraryConnected(user: UserDto): boolean{
        let x: number[] = [];
        user.groupRoles.forEach(y => x.push(y.libraryGroupId));
        // filter with distinct value by its array
        x = x.filter((v, i, a) => a.indexOf(v) === i);
        return x.length > 1 ? false : true;
    }

    createUser(): void {
        this.modalService.open(UserManagementModalComponent).result
            .then(() => { this.updateUsers(); })
            .catch(() => {});
    }

    showEditForm(user: UserDto, isGroupUser: boolean): void {
        const editForm = this.modalService.open(UserManagementModalComponent);
        editForm.componentInstance.userDto = user;
        editForm.componentInstance.isGroupUser = isGroupUser;
        editForm.result.then(() => { this.updateUsers(); })
            .catch(() => {});
    }

    showUserRoles(user: UserDto, role: Role): boolean{
        return user.groupRoles.some(r => r.role == role);
    }

    deleteUser(user: UserDto): void {
        if(window.confirm('Are you sure you want to delete this user: '+ user.emailAddress)){
            this.errorMessage = null;
            this.cloudApiService.deleteUser(user.id).subscribe(
                () => { this.updateUsers(); },
                error => { this.errorMessage = error; }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/password-reset-create/password-reset-create.component.ts